import { Routes, RouterModule } from '@angular/router';
import { UserComponent } from './user.component';
import { SavedCourseComponent } from './saved-course/saved-course.component';
import { InProgressCourseComponent } from './in-progress-course/in-progress-course.component';
import { CompletedCourseComponent } from './completed-course/completed-course.component';

export const userComponents = [UserComponent, SavedCourseComponent, InProgressCourseComponent,
  CompletedCourseComponent];

const routes: Routes = [
  {
    path: '',
    component: UserComponent,
    children: [
      {path: '', redirectTo: 'saved', pathMatch: 'full'},
      {
        path: 'saved', component: SavedCourseComponent
      },
      {
        path: 'in-progress', component: InProgressCourseComponent
      },
      {
        path: 'completed', component: CompletedCourseComponent
      }
    ]
  },
];

export const UserModuleRoutes = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-module.routing.ts